// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  sellerName: 'SASLOG SELLER',
  firebase: {
    apiKey: 'AIzaSyBR1dRWSMa2_FkqgG6c5q5fDTP3-cWc1-w',
    authDomain: 'adloggs-agency.firebaseapp.com',
    databaseURL: 'https://adloggs-agency.firebaseio.com',
    projectId: 'adloggs-agency',
    storageBucket: 'adloggs-agency.appspot.com',
    messagingSenderId: '255152308962',
    appId: '1:255152308962:web:85acfd510e6a42b694d4bb',
    measurementId: 'G-J3ES95LBSY'
  },
  Service: {
    AdloggsApiBaseUrl: 'https://preprod-ondc-saslog.adloggs.com/ekbondc/',
    AuthBaseUrl: 'https://preprod-ondc-saslog.adloggs.com/',
    AdloggsApiUrl: 'https://dev.adloggs.com/aa/',
    AdloggsApikey: '14b48174-400e-47c2-8ee6-bb77db620371',
  },
};

